import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, Box, Typography, Button } from "@mui/material";
import Lottie from "react-lottie";
import * as animationData from "../../images/diwali/Animation - 1726496643142.json";
import { useNavigate } from "react-router-dom";

export default function CongratulationsPopup() {
    const navigate = useNavigate();
    const [open, setOpen] = useState(true); // Set to true to show the popup initially
    const [isStopped, setIsStopped] = useState(false); // Control Lottie animation stop
    const [isPaused, setIsPaused] = useState(false); // Control Lottie animation pause
    const [congratsStage, setCongratsStage] = useState(0); // Track the congratulatory stage (0, 1, 2, 3)

    const handleClose = () => {
        setOpen(false);
        setIsStopped(true); // Stop the animation when the popup is closed
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            if (congratsStage < 3) {
                setCongratsStage(congratsStage + 1); // Move to the next stage
            } else {
                setIsStopped(true); // Stop the animation after all stages
                navigate("/diwali-league/index", { replace: true }); // Redirect after final stage
            }
        }, 3000); // Change stage every 5 seconds

        return () => clearTimeout(timer); // Cleanup the timer if the component is unmounted early
    }, [congratsStage]);

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        },
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullScreen
            PaperProps={{
                sx: {
                    borderRadius: 0,
                    backgroundImage: "url('https://d2sriifpjiqv0p.cloudfront.net/diwali/bg.png')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    width: "100%",
                    boxShadow: "none",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                    zIndex: "99999999999999",
                },
            }}
        >
            <DialogContent
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    padding: "2rem",
                }}
            >
                {congratsStage === 0 && (
                    <Box sx={{ position: "relative", zIndex: 2 }}>
                        <Typography sx={{ fontSize: "27px", color: "#FFD833", fontWeight:'900', lineHeight:'120%' }}>
                            Congratulations 🎉
                        </Typography>
                        <Typography sx={{ fontSize: "20px", color: "#fff", fontWeight:'600', lineHeight:'110%' }}>
                            Entered lucky draw
                        </Typography>
                    </Box>
                )}

                {congratsStage === 1 && (
                    <Box sx={{ position: "relative", zIndex: 2 }}>
                        <Typography sx={{ fontSize: "27px", color: "#FFD833", fontWeight:'900', lineHeight:'120%'}}>
                            Congratulations 🎉
                        </Typography>
                        <Typography sx={{ fontSize: "20px", color: "#fff", fontWeight:'600', lineHeight:'110%'  }}>
                            Loading all players
                        </Typography>
                    </Box>
                )}

                {congratsStage === 2 && (
                    <Box sx={{ position: "relative", zIndex: 2 }}>
                        <Typography sx={{ fontSize: "27px", color: "#FFD833", fontWeight:'900', lineHeight:'120%' }}>
                            Congratulations 🎉
                        </Typography>
                        <Typography sx={{ fontSize: "20px", color: "#fff", fontWeight:'600', lineHeight:'110%' }}>
                            Setting up your Dashboard
                        </Typography>
                    </Box>
                )}

                {congratsStage === 3 && (
                    <Box sx={{ position: "relative", zIndex: 2 }}>
                        <Typography sx={{ fontSize: "27px", color: "#FFD833", fontWeight:'900', lineHeight:'120%'}}>
                            Congratulations 🎉
                        </Typography>
                        <Typography sx={{ fontSize: "20px", color: "#fff", fontWeight:'600', lineHeight:'110%' }}>
                            Start collecting points
                        </Typography>
                    </Box>
                )}



                <Lottie
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        zIndex: 1, // Make sure it's behind the text
                    }}
                    options={defaultOptions}
                    height={`100%`}
                    width={`100%`}
                    isStopped={isStopped}
                    isPaused={isPaused}
                />
            </DialogContent>
        </Dialog>
    );
}
